import React from 'react';
import {Provider} from "components/app-version/AppVersionContext";
import {AppVersionList} from "components/app-version/AppVersionList";

export const AppVersions = () => {

    return (
        <Provider>
            <AppVersionList/>
        </Provider>
    );
}
